import { Controller } from "@hotwired/stimulus"

// Adds an emoji button to a Lexxy editor's toolbar and inserts the chosen
// emoji at the cursor. Lexxy builds its toolbar itself when the editor
// initialises, so the button is added from a <template> once that toolbar
// exists. The panel closes on Escape (focus back to the button), on picking
// an emoji (focus back to the text) or on a click elsewhere.
export default class extends Controller {
  static targets = ["panel", "buttonTemplate"]

  connect() {
    this.editor = this.element.querySelector("lexxy-editor")
    this.onOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }

    if (!this.addButton()) {
      this.onInitialize = () => requestAnimationFrame(() => this.addButton())
      this.editor?.addEventListener("lexxy:initialize", this.onInitialize, { once: true })
    }
  }

  disconnect() {
    this.editor?.removeEventListener("lexxy:initialize", this.onInitialize)
    document.removeEventListener("click", this.onOutsideClick)
  }

  addButton() {
    const toolbar = this.editor?.querySelector("lexxy-toolbar")
    if (!toolbar) return false
    if (toolbar.querySelector("button[name='emoji']")) return true

    this.button = this.buttonTemplateTarget.content.firstElementChild.cloneNode(true)
    this.button.addEventListener("click", () => this.toggle())
    // After the formatting buttons, before the push-right group (undo/redo).
    const anchor = toolbar.querySelector(".lexxy-editor__toolbar-button--push-right")
    toolbar.insertBefore(this.button, anchor)
    toolbar.requestOverflowRefresh?.()
    return true
  }

  toggle() {
    this.panelTarget.hidden ? this.open() : this.closeAndReturn()
  }

  open() {
    this.panelTarget.hidden = false
    this.button?.setAttribute("aria-expanded", "true")
    this.panelTarget.querySelector("button")?.focus()
    document.addEventListener("click", this.onOutsideClick)
  }

  close() {
    this.panelTarget.hidden = true
    this.button?.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this.onOutsideClick)
  }

  closeAndReturn() {
    this.close()
    this.button?.focus()
  }

  insert(event) {
    this.close()
    this.editor.focus()
    this.editor.contents.insertHtml(event.currentTarget.dataset.emoji)
  }
}
